import { useState, useRef, useCallback, useMemo } from 'preact/hooks';
import { defaultBreakpoints, Breakpoints } from '../UNSAFE_useBreakpoints';

/*
 * This custom hook returns the current breakpoints based on the width of a container, which is a DOM object.
 * The breakpoints are returned as a set of boolean values keyed to each breakpoint.
 *
 * TODO: Refactor to use a single ResizeObserver for better performance
 */
export function useContainerBreakpoints(breakpoints: Breakpoints = defaultBreakpoints) {
  const [width, setWidth] = useState(0);
  const observedNodeRef = useRef<HTMLElement | null>(null);

  const resizeObserver = useMemo(
    () =>
      new ResizeObserver((entries) => {
        for (const entry of entries) {
          setWidth(entry.contentRect.width);
        }
      }),
    []
  );

  const ref = useCallback(
    (node: HTMLElement) => {
      const observedNode = observedNodeRef.current;

      if (node != observedNode) {
        if (observedNode) {
          resizeObserver.unobserve(observedNode);
        }

        if (node) {
          resizeObserver.observe(node);
        }

        observedNodeRef.current = node;
      }
    },
    [resizeObserver]
  );

  const breakpointMatches = useMemo(() => {
    const matches: Record<string, boolean> = {};
    for (const k in breakpoints) {
      matches[k] = width >= parseInt(breakpoints[k]);
    }
    return matches;
  }, [width, breakpoints]);

  return { breakpointMatches, ref };
}
